import * as React from 'react';
const SvgMenu = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="evenodd">
         <path d="M36.964 22.051a5.057 5.057 0 1 1 0-10.113 5.057 5.057 0 0 1 0 10.113M18.036 22.051a5.057 5.057 0 1 1 0-10.113 5.057 5.057 0 0 1 0 10.113M36.964 43.065a5.057 5.057 0 1 1 0-10.113 5.057 5.057 0 0 1 0 10.113M18.036 43.065a5.057 5.057 0 1 1 0-10.113 5.057 5.057 0 0 1 0 10.113" />
      </g>
   </svg>
);
export default SvgMenu;
